// ********************************************************
// Admin
// Handles stuff like corporations and users.
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadCorporations () {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadCorporations'
  })
  return res
}

export async function saveCorporation (corporation) {
  const res = await Backend.callApi({
    apiName: 'Admin.SaveCorporation',
    inputData: {
      Corporation: corporation
    }
  })
  return res
}

export async function loadCorporation (id) {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadCorporation',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadClaims (id) {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadClaims',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadFacilities (corporationId) {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadFacilities',
    inputData: {
      CorporationId: corporationId
    }
  })
  return res
}

export async function loadFacility (id) {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadFacility',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function saveFacility (facility) {
  const res = await Backend.callApi({
    apiName: 'Admin.SaveFacility',
    inputData: {
      Facility: facility
    }
  })
  return res
}

export async function removeFacility (facility) {
  const res = await Backend.callApi({
    apiName: 'Admin.SaveFacility',
    inputData: {
      Facility: facility
    }
  })
  return res
}

export async function loadUserGroups (corporationId) {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadUserGroups',
    inputData: {
      CorporationId: corporationId
    }
  })
  return res
}

export async function loadUserGroup (id) {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadUserGroup',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadUserDetails (id) {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadUserDetails',
    inputData: {
      Id: id
    }
  })
  return res
}

// export async function saveUserDetail (userDetail) {
//   const res = await Backend.callApi({
//     apiName: 'Admin.SaveUserDetail',
//     inputData: {
//       UserDetail: userDetail
//     }
//   })
//   return res
// }

// export async function loadUserDetail (userId, detailName) {
//   const res = await Backend.callApi({
//     apiName: 'Admin.LoadUserDetail',
//     inputData: {
//       UserId: userId,
//       DetailName: detailName
//     }
//   })
//   return res
// }

export async function saveUserGroup (userGroup) {
  const res = await Backend.callApi({
    apiName: 'Admin.SaveUserGroup',
    inputData: {
      UserGroup: userGroup
    }
  })
  return res
}

export async function removeUserGroup (userGroup) {
  const res = await Backend.callApi({
    apiName: 'Admin.SaveUserGroup',
    inputData: {
      UserGroup: userGroup
    }
  })
  return res
}

export async function loadUsers (params) {
  const res = await Backend.callApi({
    apiName: 'Admin.LoadUsers',
    inputData: {
      SearchText: params.searchText
    }
  })
  return res
}

export async function loadUser (id) {
  // console.log('--> ADMIN loadUser: ', id)
  const res = await Backend.callApi({
    apiName: 'Admin.LoadUser',
    inputData: {
      Id: id
    }
  })

  return res
}

export async function saveUser (user) {
  // console.log('--> ADMIN saveUser: ', user)
  const res = await Backend.callApi({
    apiName: 'Admin.SaveUser',
    inputData: {
      User: user
    }
  })

  return res
}

export async function removeUser (user) {
  const res = await Backend.callApi({
    apiName: 'Admin.SaveUser',
    inputData: {
      User: user
    }
  })

  return res
}
